<template>
  <v-navigation-drawer v-model="drawerActive" absolute right bottom temporary width="400" style="z-index:10">
    <v-toolbar dense>
      <v-toolbar-title>To-Do List</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon aria-label="Close To-Do List" @click="drawerActive = false">
        <v-icon>fal fa-times</v-icon>
      </v-btn>
    </v-toolbar>
    <v-tabs v-model="todoTab" grow>
      <v-tab>
        Active {{ activeToDos.length > 0 ? '(' + activeToDos.length + ')' : '' }}
      </v-tab>
      <v-tab :disabled="doneToDos.length === 0">
        Done {{ doneToDos.length > 0 ? '(' + doneToDos.length + ')' : '' }}
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="todoTab">
      <v-tab-item>
        <v-list>
          <template v-for="(item, index) in activeToDos">
            <language-test-dialog v-if="item.isLanguageTest || item.linkType === 'language'" :key="'langTestToDo-' + index" :item="item" />
            <math-test-dialog v-else-if="item.linkType === 'math'" :key="'mathTestToDo-' + index" :item="item" />
            <to-do-test-dialog v-else-if="item.isExternalLink || item.linkType === 'external'" :key="'activeTestToDo-' + index" :item="item" @click="todoMenu = false"></to-do-test-dialog>
            <v-list-item v-else :key="'activeToDo-' + index" @click="openLink(item.link)">
              <v-list-item-avatar>
                <v-icon :title="item.title + (item.link.substr(0, 4) === 'http' ? ' (external link; opens in new window)' : '')">
                  {{ item.link.substr(0, 4) === 'http' ? 'fal fa-external-link' : 'fal fa-arrow-alt-circle-right' }}
                </v-icon>
              </v-list-item-avatar>
              <v-list-item-title style="white-space:normal;overflow:visible">
                <v-badge v-if="!item.viewed" color="red" dot left>{{ item.title }}</v-badge>
                <span v-else>{{ item.title }}</span>
              </v-list-item-title>
              <v-list-item-action v-if="item.link.substr(0, 4) === 'http'">
                <v-menu>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon>
                      <v-icon>fal fa-ellipsis-v</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="openLink(item.link)">
                      <v-list-item-content>
                        <v-list-item-title>Do This Action Item</v-list-item-title>
                        <v-list-item-subtitle>This link will take you to a page outside of Scots Connect to complete.</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item @click="dismissAction(item)">
                      <v-list-item-content>
                        <v-list-item-title>Dismiss Item</v-list-item-title>
                        <v-list-item-subtitle>Remove from your active to-do list</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-list-item-action>
            </v-list-item>
          </template>
          <v-list-item v-if="activeToDos.length === 0">
            <v-list-item-title style="white-space:normal">There is currently nothing on your to-do list.</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-tab-item>
      <v-tab-item>
        <v-list>
          <v-list-item v-for="({ title, link }, index) in doneToDos" :key="'doneToDo-' + index">
            <v-list-item-title style="white-space:normal">{{ title }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-tab-item>
    </v-tabs-items>
  </v-navigation-drawer>
</template>
<script>
import { ref, computed, watch, onMounted } from '@vue/composition-api'

export default {
  components: {
    LanguageTestDialog: () => import('./LanguageTestDialog'),
    MathTestDialog: () => import('./MathTestDialog'),
    ToDoTestDialog: () => import('./ToDoTestDialog')
  },
  setup (props, { root, emit }) {
    const drawerActive = computed({
      get: () => root.$store.state.actionNavBarActive,
      set: (val) => root.$store.commit('setActionNavBarActive', val)
    })
    watch(drawerActive, () => {
      if (drawerActive.value) {
        setTimeout(() => { clearViewed() }, 3000)
      }
    })

    const actionBase = ref([])

    onMounted(async () => {
      const aggregate = [
        { $match: { term: root.$store.state.term, 'actions.0': { $exists: true } } },
        { $unwind: '$actions' },
        { $project: {
          _id: '$actions._id',
          title: '$actions.title',
          link: '$actions.link',
          isExternalLink: '$actions.isExternalLink',
          isPlacementTest: '$actions.isPlacementTest',
          dialogText: '$actions.dialogText',
          linkText: '$actions.linkText',
          dismissText: '$actions.dismissText',
          doneText: '$actions.doneText',
          popupText: '$actions.popupText',
          openDate: '$actions.openDate',
          condition: '$actions.condition'
        } }
      ]
      const { data } = await root.$feathers.service('orientation/section').find({ query: { aggregate } })
      actionBase.value = data
    })

    const user = computed(() => root.$store.state.user)
    const todoTab = ref(0)
    const activeToDos = computed(() => {
      let arr = []
      for (let i = 0; i < root.$store.state.actions.length; i++) {
        if (!root.$store.state.actions[i].done && !root.$store.state.actions[i].dismissed) {
          const rec = actionBase.value.find(({ title, link }) => title === root.$store.state.actions[i].title || link === root.$store.state.actions[i].link)
          arr.push({ ...root.$store.state.actions[i], index: i, ...rec })
        }
      }
      return arr
    })
    const doneToDos = computed(() => {
      let arr = []
      for (let i = 0; i < root.$store.state.actions.length; i++) {
        if (root.$store.state.actions[i].done) {
          arr.push({ ...root.$store.state.actions[i], index: i })
        }
      }
      return arr
    })

    const todoMenu = ref(false)

    function openLink (link) {
      if (link.substr(0, 1) === '/') root.$store.commit('setLink', link)
      else window.open(link, '_blank')
      todoMenu.value = false
    }
    function dismissAction (item) {
      root.$feathers.service('orientation/tracker').patch(root.$store.state.tracker.id, { ['actions.' + item.index + '.dismissed']: true }).then(({ actions }) => {
        root.$store.commit('setActions', actions)
      })
    }

    function clearViewed () {
      let obj = {}
      let changed = false
      for (let i = 0; i < activeToDos.value.length; i++) {
        if (!activeToDos.value[i].viewed) {
          obj['actions.' + i + '.viewed'] = new Date()
          changed = true
        }
      }
      if (changed) {
        root.$feathers.service('orientation/tracker').patch(root.$store.state.tracker.id, obj).then(({ actions }) => {
          root.$store.commit('setActions', actions)
        })
      }
    }

    return {
      drawerActive,
      user,
      todoTab,
      activeToDos,
      doneToDos,
      openLink,
      dismissAction
    }
  }
}
</script>
